import { ResolvedLink } from "../types/components";

export const useHelper = () => {
  // from lodash.unescape https://github.com/lodash/lodash/blob/master/unescape.js
  // add &#x27;
  const unescape = (string) => {
    const htmlUnescapes = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'",
      "&#x27;": "'",
    };
    const reEscapedHtml = /&(?:amp|#x27|lt|gt|quot|#(0+)?39);/g;
    const reHasEscapedHtml = RegExp(reEscapedHtml.source);

    return string && reHasEscapedHtml.test(string)
      ? string.replace(reEscapedHtml, (entity) => htmlUnescapes[entity] || "'")
      : string || "";
  };

  const handleClickOnCustomContentLink = (link?: ResolvedLink) => {
    if (link?.url && link?.external) {
      window.open(link?.url, "_blank");
    } else if (link?.url) {
      window.location.href = link?.url;
    }
  };

  return {
    handleClickOnCustomContentLink,
    unescape,
  };
};
